export const vsComponentName = "contractInfoComponent";
